var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFpass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13320",
    "data-name": "Group 13320",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.42,
    height: 67.8,
    viewBox: "0 0 48.42 67.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4713",
    "data-name": "Rectangle 4713",
    width: 48.42,
    height: 67.8,
    fill: "#36dae9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10427",
    "data-name": "Group 10427",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M7.262,24.2v-.416c0-2.408-.02-4.815,0-7.223A16.24,16.24,0,0,1,14.31,2.917a15.867,15.867,0,0,1,8.7-2.88,18.074,18.074,0,0,1,7.688,1.077,15.857,15.857,0,0,1,9.9,11.166,18.358,18.358,0,0,1,.534,3.841,2.427,2.427,0,0,1-2.849,2.507,2.516,2.516,0,0,1-1.965-2.534A10.668,10.668,0,0,0,34.8,10.552a10.975,10.975,0,0,0-8.7-5.614,14.06,14.06,0,0,0-6.026.427A11.364,11.364,0,0,0,12.2,14.613a6.242,6.242,0,0,0-.093,1.129c-.008,2.722,0,5.445,0,8.168v.313h.5c9.417,0,18.834-.015,28.251.009a7.163,7.163,0,0,1,6.905,4.338,7.241,7.241,0,0,1,.653,3.157c.008,7.4.03,14.8-.008,22.2a13.431,13.431,0,0,1-3.121,8.793,13.684,13.684,0,0,1-9.735,5c-.539.045-1.082.065-1.623.066-6.669,0-13.338.036-20.006-.009A13.461,13.461,0,0,1,3.484,63.1,13.465,13.465,0,0,1,.066,54.926C.029,54.386,0,53.845,0,53.3Q0,42.451,0,31.6a7.323,7.323,0,0,1,6.6-7.315c.211-.022.42-.054.663-.085m16.961,4.864H7.358a2.37,2.37,0,0,0-2.518,2.5q0,11.286,0,22.571a8.576,8.576,0,0,0,.506,2.885,8.935,8.935,0,0,0,8.584,5.934c6.92-.022,13.839,0,20.759-.013a9.624,9.624,0,0,0,1.726-.157,8.9,8.9,0,0,0,7.159-8.615q0-9.357,0-18.715c0-1.285.008-2.571,0-3.857a2.463,2.463,0,0,0-2.557-2.534H24.223",
    transform: "translate(0 0)",
    fill: "#36dae9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M66.324,132.8c0-1.247-.005-2.495,0-3.742a.562.562,0,0,0-.278-.548,4.776,4.776,0,0,1-1.854-5.52,4.843,4.843,0,0,1,4.917-3.26,4.728,4.728,0,0,1,4.293,3.617,4.8,4.8,0,0,1-1.941,5.141.614.614,0,0,0-.306.606q.011,3.742,0,7.484a2.411,2.411,0,0,1-4.677.889,3.425,3.425,0,0,1-.154-.963c-.017-1.235-.007-2.469-.007-3.7",
    transform: "translate(-44.538 -83.396)",
    fill: "#36dae9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFpass);
export default __webpack_public_path__ + "static/media/fpass.e41f4cbe2892a14212d13b5adab8bf71.svg";
export { ForwardRef as ReactComponent };